import { atom } from 'jotai';

export const tierCalculatedDateAtom = atom<string>();
